export default "__VITE_ASSET__CDmUsCNJ__"